import React from 'react';

import {
  BaseWidget,
  PermissionWall
} from 'modules/layer01';
import {
  Button,
  Grid,
  Typography
} from '@mui/material';

import { LabelledText } from 'modules/layer00';
import { Edit } from '@mui/icons-material';
import { modalUtil } from 'iron-forge-react-modules';
import * as EditOrderModal from './EditOrderModal/EditOrderModal';
import * as dataService from './dataService';



export interface IProps {
  orderId: string;
  storeId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.orderId);
  const { setModalIsOpen, modalType2IsOpen } = modalUtil.useModalTrackers(['editCustomer']);



  const handleClickEditCustomer = React.useCallback(
    () => {
      setModalIsOpen('editCustomer', true);
    },
    [setModalIsOpen]
  );



  const order = queryTuple.data.order;
  return order ? (
    <>
      <BaseWidget.FC
        title="Customer Information"
        elAction={(
          <PermissionWall.FC
            storeId={props.storeId}
            requiresPermissions={[
              'customer_editPersonalInformation',
              'salesOrder_editAddress'
            ]}>
            <Button
              startIcon={<Edit />}
              onClick={handleClickEditCustomer}>
              Edit
            </Button>
          </PermissionWall.FC>
        )}>
        <Grid container>
          <Grid
            item
            xs={12}
            md={4}>
            <LabelledText.FC
              title="Full Name"
              text={order.customer.fullName ?? 'N/A'} />

            <LabelledText.FC
              title="Email"
              text={order.customer.email ?? ''} />

            <LabelledText.FC
              title="Phone Number"
              text={order.customer.phoneNumber ?? 'N/A'} />
          </Grid>

          <Grid
            item
            xs={12}
            md={4}>
            <LabelledText.FC
              title="Billing Address"
              text={__address2Component(order.billingAddress)} />
          </Grid>

          <Grid
            item
            xs={12}
            md={4}>
            <LabelledText.FC
              title="Shipping Address"
              text={__address2Component(order.shippingAddress)} />
          </Grid>
        </Grid>
      </BaseWidget.FC>

      {modalType2IsOpen.editCustomer && (
        <EditOrderModal.FC
          orderId={props.orderId}
          onClose={() => setModalIsOpen('editCustomer', false)}
          onSubmit={() => setModalIsOpen('editCustomer', false)} />
      )}
    </>
  ) : null;
};



function __address2Component(addr: dataService.IAddress) {
  return (
    <>
      <Typography>
        {addr.addressee}
      </Typography>

      <Typography>
        {addr.street1}
      </Typography>

      <Typography>
        {addr.street2}
      </Typography>

      <Typography>
        {addr.city}, {addr.usState}, {addr.postalCode}
      </Typography>
    </>
  );
}
